import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Box, Button, Flex, IconButton, Table, Td, Tr } from '@chakra-ui/react';
import { MdCopyAll } from 'react-icons/md';
import { FaCopy } from 'react-icons/fa6';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { useAlert, useEntityState, useIsAdmin } from '@app/hooks';
import { api } from '@app/api';

import Error404 from '../../pages/errors/404';
import { UserForm } from './form';
import { mapInstance } from './utils/mapInstance';
import { UserFormInstance } from './types';
import { useAvailableUsers } from './hooks/useAvailableUsers';
import { Dialog, Txt } from '../common';


const UserCreate = () => {
  useHeader('Добавить пользователя', []);
  const isAdimn = useIsAdmin();
  const history = useHistory();
  const { error, success } = useAlert();

  const [instance, onChange ] = useEntityState<UserFormInstance>({});
  const [username, setUsername] = useState('');
  const [createSuccessDialog, setCreateSuccessDialog] = useState(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const { availableUsers, loadingUsers } = useAvailableUsers();

  const onFormSubmit = async (user: Partial<UserFormInstance>) => {
    setIsFetching(true);
    try {
      const response = await api.users.create(mapInstance(user));
      if(response.data.code === 200) {
        setIsFetching(false);
        success('Пользователь добавлен');
        setUsername(response.data.data.username);
        setCreateSuccessDialog(true);
      } else {
        setIsFetching(false);
        error(response.data.message);
      }
    } catch (e) {
      console.log(e);

      setIsFetching(false);
      error(e.message);
    }
  };

  const onFormCancel = () => {
    history.goBack();
  };

  if (!isAdimn) {
    return <Error404 />;
  }

  return (<>
    <UserForm
      action='create'
      instance={instance}
      availableUsers={availableUsers}
      loadingUsers={loadingUsers}
      onSubmit={onFormSubmit}
      onCancel={onFormCancel}
      onChange={onChange}
    />
    <Dialog
      title="Пользователь создан"
      open={createSuccessDialog}
      onClose={() => {
        setCreateSuccessDialog(false);
        history.goBack();
      }}
      actions={<Flex gap={4} justifyContent='flex-end'>
        <IconButton colorScheme='brand' 
          onClick={() => {
            navigator.clipboard.writeText(`
Доступ к SNEG предоставлен:
              
Логин: ${username}
Пароль: ${instance.password}
            `);
            success('Данные пользователя скопированы в буфер обмена');
          } } 
          aria-label="copy"
        >
          <FaCopy />
        </IconButton>
        <Button onClick={() => {
          setCreateSuccessDialog(false);
          history.goBack();
        }}
        >Закрыть</Button>
      </Flex>}
      width='auto'
    >
      <Box display='flex' flexDirection='column' gap={4}>
        <Txt>Доступ к SNEG предоставлен:</Txt>

        <Table variant='simple' size='sm' colorScheme='brand' width='100%'>
          <Tr>
            <Td fontWeight='bold'>ФИ</Td>
            <Td fontWeight='bold'>Email</Td>
            <Td fontWeight='bold'>Имя пользователя</Td>
            <Td fontWeight='bold'>Пароль</Td>
          </Tr>
          <Tr>
            <Td>{instance.last_name} {instance.first_name}</Td>
            <Td>{instance.email}</Td>
            <Td>{username}</Td>
            <Td>{instance.password}</Td>
          </Tr>
        </Table>        
      </Box>
    </Dialog>
  </>);
};

export default UserCreate;
